function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="86" height="60" xmlns="http://www.w3.org/2000/svg" {...props}><text transform="translate(-39 -52)" fill="#FFF" fillRule="evenodd" fontFamily="AppleColorEmoji, Apple Color Emoji" fontSize="86"><tspan x="39" y="114">🤝</tspan></text></svg>;
});